var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { Card } from "@irati/ui/src/Layout";
import { Para } from "../../ui/Labels";
import { MessageHeader } from "./";
var StyledCard = styled(Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 15px;\n"], ["\n  margin-top: 15px;\n"])));
var Text = styled(Para)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 15px;\n"], ["\n  margin-top: 15px;\n"])));
var Message = function (_a) {
    var message = _a.message;
    var text = message.text, user = message.user, createdAt = message.createdAt;
    return (React.createElement(StyledCard, { small: true },
        React.createElement(MessageHeader, { user: user, date: createdAt }),
        React.createElement(Text, { medium: true }, text)));
};
export default Message;
var templateObject_1, templateObject_2;
